import './index.less'
import React from 'react'

interface IProps {
  info: string | React.ReactNode
  SvgIcon: React.FC<React.SVGProps<SVGSVGElement>>
}

const WidgetInfo = (props: IProps) => {
  const { info, SvgIcon } = props

  return (
    <div className="roles-widget-info-container">
      <div className="container-icon">
        <SvgIcon />
      </div>
      {info}
    </div>
  )
}

export default WidgetInfo
